import { IMAGE_NODE } from "@repo/fika-blog/src/nodes/imageNode"
import type { Editor } from "@repo/fika-blog/src/tiptap/core"
import type { UploadFolder } from "@repo/fika-shared/src/upload-folder.js"
import { ulid } from "ulid"
import { uploadImage } from "@/data/upload-image"

function fileToDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

function getImageDimensions(
  src: string,
): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () =>
      resolve({ width: img.naturalWidth, height: img.naturalHeight })
    img.onerror = reject
    img.src = src
  })
}

export async function insertImageIntoEditor({
  editor,
  file,
  uploadFolder,
  insertAt,
}: {
  editor: Editor
  file: File
  uploadFolder: UploadFolder
  insertAt?: number
}) {
  const dataUrl = await fileToDataUrl(file)
  const { width, height } = await getImageDimensions(dataUrl)
  const uid = ulid()

  if (insertAt !== undefined) {
    editor
      .chain()
      .insertContentAt(insertAt, {
        type: IMAGE_NODE,
        attrs: { src: dataUrl, uid, width, height },
      })
      .focus()
      .run()
  } else {
    editor
      .chain()
      .focus()
      .insertContent({
        type: IMAGE_NODE,
        attrs: { src: dataUrl, uid, width, height },
      })
      .run()
  }

  uploadImage(file, uploadFolder)
    .then(url => {
      editor.state.doc.descendants((node, position) => {
        if (node.type.name === IMAGE_NODE && node.attrs.uid === uid) {
          editor
            .chain()
            .setNodeSelection(position)
            .updateAttributes(IMAGE_NODE, { src: url })
            .run()
        }
      })
    })
    .catch(error => {
      console.error("failed to upload image:", error)
    })
}
